module.exports = __webpack_public_path__ + "static/media/11.852ee9b9.png";